import "./Switches.css";

export const Switches = ({
  size,
  type,
  value,
  onChange,
  customStyles,
  content,
  label,
  id,
  disabled,
  title,
  "aria-label": ariaLabel,
}) => {
  const handleChange = (e) => {
    if (onChange) {
      onChange(e);
    }
  };

  const isChecked = value === true || value === "true" || value === 1;

  return (
    <>
      {label && <p className={`font-12`}>{label}</p>}
      <div className={`form-switch ${size || ""} ${type || ""}`.trim()} style={customStyles} title={title}>
        <input
          type="checkbox"
          id={id}
          checked={isChecked}
          onChange={handleChange}
          disabled={disabled}
          aria-checked={isChecked}
          role="switch"
          aria-label={ariaLabel}
        />
        <div className="check">
          <i className="content">{content}</i>
        </div>
      </div>
    </>
  );
};
